import classNames from "classnames";
import { useTranslation } from "react-i18next";

import styles from "./empty.module.scss";

export function EmptyFeedbackList() {
  const { t } = useTranslation();
  return (
    <div className={styles.emptyListContainer}>
      <div className={classNames(styles.mb2, styles.mt2)}>
        <img src="../../../assets/images/svg/emptyFeedback.svg" />
      </div>
      <p className={styles.h3}> {t("lbl_empty_reviews")} </p>
    </div>
  );
}
